import { React } from 'react';
import { Trans } from 'react-i18next';
import satelliteLinks from '../satelliteLinks';

// Renders `<prefix>.text` with the TextGroup styles; each <br/> in the text starts a new paragraph (smaller gap than after a title)
// first: space above the text (right after a section title)
// noPadBottom: no space after the text (end of a section)
const SatelliteText = props => {
    let className = [];
    if (props.first) className.push('first');
    if (props.noPadBottom) className.push('noPadBottom');
    return (
        <div className='text-container'>
            <p className={className.join(' ')}>
                <Trans t={props.t} i18nKey={props.prefix + '.text'} components={{ ...satelliteLinks(props.t), br: <span className='paragraph-break' /> }} />
            </p>
        </div>
    );
};

export default SatelliteText;
